import { render, staticRenderFns } from "./PensionInsurance.vue?vue&type=template&id=6c4cf586&"
import script from "./PensionInsurance.vue?vue&type=script&lang=js&"
export * from "./PensionInsurance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports